module.exports = {"id":"dp2_5l1q3","text":"Digital Behaviour","instructions":"Some online behaviour can result in legal consequences.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"2.5","questionType":"PickOne","random":false,"options":[{"id":"dp2_5l1q3-a1","text":"True","score":1.8},{"id":"dp2_5l1q3-a2","text":"Not sure","score":0},{"id":"dp2_5l1q3-a3","text":"False","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.5/l1q3.json
// module id = 1069
// module chunks = 41